import React, { Component } from 'react'
//import TableComp from '../../../../components/_utils/table'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import S from 'string'
import _ from 'lodash'
import { Button, Card, Col, Row } from 'antd'

import Request, { API_URL } from '../../request'

import { connect } from 'react-redux'
import styles from './styles.less'
import userRights from '../../components/_utils/userRights'

const visaFillingBy = ['Agent', 'Applicant', 'Either']
const interviewArr = ['Yes', 'No', 'May Be']
const optionsArr = [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'No' }]

class CollapseViewBox extends Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>{this.props.children}</div>
            <a style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </a>
        </React.Fragment>
    }
}

class CountryReports extends Component {
    state = {
        total: 0,
        loading: false,
        visaCategoryList: ['571', '572', '573', 'SPP', 'SVP', 'IPP'],
        countryArr: [],
        visaMainApplicantArr: []


    }
    apiRequest = params => {
        let dateFilter = null
        return new Promise(async resolve => {

            this.setState({ exportParams: params })

            let data = await Request.getCountryReportData({
                ...params,
                regExFilters: ['countryCode', 'currencyName',
                    'airTicketType',
                    'mainStates', 'mainCities', 'embassyAddress',
                    'embassyContacts', 'partTimeWork', 'visaProcessingTime',
                    'tutionFeeReq', 'fundAcceptable', 'fundRefundable',
                    'fundSponsors', 'enrollmentBasic', 'enrollmentRemarks', 'enrollmentProcedure'
                ]


            })

            this.setState({ total: data.total })
            resolve(data)
        })
    }
    exportExcel = async () => {
        const { exportParams } = this.state

        this.setState({ loading: true })
        let x = await Request.exportCountryDataToExcel({
            ...exportParams, regExFilters: ['countryCode', 'currencyName',
                'airTicketType',
                'mainStates', 'mainCities', 'embassyAddress',
                'embassyContacts', 'partTimeWork', 'visaProcessingTime',
                'tutionFeeReq', 'fundAcceptable', 'fundRefundable',
                'fundSponsors', 'enrollmentBasic', 'enrollmentRemarks', 'enrollmentProcedure'
            ]
        })
        this.setState({ loading: false })


        if (!x.error) {
            window.open(x.url)
        }


    }
    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    componentDidMount() {
        this.loadCountry()
        this.getVisaFeeMainApplicantFilter()
    }

    async getVisaFeeMainApplicantFilter() {
        let resp = await Request.getVisaFeeMainApplicantFilter()
        this.setState({ visaMainApplicantArr: resp })
    }

    loadCountry() {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend'
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    let temp = []
                    _.each(resp.data, (vv) => {
                        temp.push({
                            text: vv.countryName,
                            value: vv.countryName
                        })
                    })
                    this.setState({ countryArr: temp })

                }
            })
            .catch(err => {
            })

    }

    render() {
        const { dispatch } = this.props
        const { visaCategoryList, countryArr, visaMainApplicantArr } = this.state


        const columns = [
            {
                title: 'Country Name',
                dataIndex: 'countryName',
                key: 'countryName',
                width: 100,
                fixed: 'left',
                filters: countryArr

            },
            {
                title: 'Code',
                dataIndex: 'countryCode',
                key: 'countryCode',
                searchTextName: 'countryCode',
                filterRegex: true
            },
            {
                title: 'Currency',
                dataIndex: 'currencyName',
                key: 'currencyName',
                searchTextName: 'currencyName',
                filterRegex: true
            },
            {
                title: 'Currency Rate', dataIndex: 'currencyRate',
                searchTextName: 'currencyRate'
            },
            {
                title: 'Total Consultancy Fee',
                dataIndex: 'totalConsultancyFee',
                key: 'totalConsultancyFee',
                searchTextName: 'totalConsultancyFee'
            },
            {
                title: 'Stage 1 Fee',
                dataIndex: 'stageApplication',
                key: 'stageApplication',
                searchTextName: 'stageApplication'
            },
            {
                title: 'Stage 2 Fee',
                dataIndex: 'stageVisaFilling',
                key: 'stageVisaFilling',
                searchTextName: 'stageVisaFilling'
            },
            {
                title: 'Stage 3 Fee',
                dataIndex: 'stageVisaApproval',
                key: 'stageVisaApproval',
                searchTextName: 'stageVisaApproval'
            },
            {
                title: 'Visa Fee (Main) Applicant', dataIndex: 'visaFeeMainApplicant', key: 'visaFeeMainApplicant',
                filters: visaMainApplicantArr && visaMainApplicantArr.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Visa Fee (Main) Spouse', dataIndex: 'visaFeeSpouse', key: 'visaFeeSpouse',
                searchTextName: 'visaFeeSpouse'
            },
            {
                title: 'Child1', dataIndex: 'visaFeeChild1', key: 'visaFeeChild1',
                searchTextName: 'visaFeeChild1'
            },
            {
                title: 'Child2', dataIndex: 'visaFeeChild2', key: 'visaFeeChild2',
                searchTextName: 'visaFeeChild2'
            },
            {
                title: 'Child3', dataIndex: 'visaFeeChild3', key: 'visaFeeChild3',
                searchTextName: 'visaFeeChild3'
            },
            {
                title: 'Child4', dataIndex: 'visaFeeChild4', key: 'visaFeeChild4',
                searchTextName: 'visaFeeChild4'
            },
            {
                title: 'VFS/TTS Fee Each Applicant', dataIndex: 'totalVfsFee', key: 'totalVfsFee',
                searchTextName: 'totalVfsFee'
            },
            {
                title: 'Resident Permit Fee', dataIndex: 'totalPermitFee', key: 'totalPermitFee',
                searchTextName: 'totalPermitFee'
            },


            {
                title: 'Living Cost (Main) Applicant',
                dataIndex: 'livingCostMainApplicant',
                key: 'livingCostMainApplicant',
                searchTextName: 'livingCostMainApplicant'
            },
            {
                title: 'Living Cost (Main) Spouse', dataIndex: 'livingCostSpouse', key: 'livingCostSpouse',
                searchTextName: 'livingCostSpouse'
            },
            {
                title: 'Living Cost Main Child 1', dataIndex: 'livingCostChild1', key: 'livingCostChild1',
                searchTextName: 'livingCostChild1'
            },
            {
                title: 'Living Cost Main Child 2', dataIndex: 'livingCostChild2', key: 'livingCostChild2',
                searchTextName: 'livingCostChild2'
            },
            {
                title: 'Living Cost Main Child 3', dataIndex: 'livingCostChild3', key: 'livingCostChild3',
                searchTextName: 'livingCostChild3'
            },
            {
                title: 'Living Cost Main Child 4', dataIndex: 'livingCostChild4', key: 'livingCostChild4',
                searchTextName: 'livingCostChild4'
            },


            {
                title: 'Schooling Cost Per Year Child', dataIndex: 'childrenAboveAge', key: 'childrenAboveAge',
                searchTextName: 'childrenAboveAge'
            },
            {
                title: 'Travel Cost Main Applicant',
                dataIndex: 'travelCostMainApplicant',
                key: 'travelCostMainApplicant',
                searchTextName: 'travelCostMainApplicant'
            },
            {
                title: 'Travel Cost Main Spouse', dataIndex: 'travelCostSpouse', key: 'travelCostSpouse',
                searchTextName: 'travelCostSpouse'
            },
            {
                title: 'Travel Cost Main Child', dataIndex: 'travelCostChild', key: 'travelCostChild',
                searchTextName: 'travelCostChild'
            },
            {
                title: 'Estimated Accommodation Cost per year Single',
                dataIndex: 'singleEstimatedCost',
                key: 'singleEstimatedCost',
                searchTextName: 'singleEstimatedCost'
            },
            {
                title: 'Estimated Accommodation Cost per year Family',
                dataIndex: 'familyEstimatedCost',
                key: 'familyEstimatedCost',
                searchTextName: 'familyEstimatedCost'
            },
            {
                title: 'Air Ticket Type', dataIndex: 'airTicketType', key: 'airTicketType',
                searchTextName: 'airTicketType',
                filterRegex: true
            },
            {
                title: 'Air Ticket Price', dataIndex: 'airTicketPrice', key: 'airTicketPrice',
                searchTextName: 'airTicketPrice'
            },
            {
                title: 'Flag', dataIndex: 'flagImage',
                key: 'flagImage',
                searchTextName: 'flagImage',
                filterRegex: true,
                render: (val, record) => {
                    if (record && record.flagImage && record.flagImage.length > 0) {
                        let url = `${record.flagImage[0].url}`
                        let ind = url && url.indexOf('http')
                        url = ind >= 0 ? `${url}` : `${API_URL}${url}`
                        return (<a href={url} target={'_blank'}>
                            <img src={url} />
                        </a>)
                    } else {
                        return (<></>)
                    }
                }
            },
            {
                title: 'Main States', dataIndex: 'mainStates', key: 'mainStates',
                searchTextName: 'mainStates',
                filterRegex: true
            },
            {
                title: 'Main Cities', dataIndex: 'mainCities', key: 'mainCities',
                searchTextName: 'mainCities',
                filterRegex: true
            },
            {
                title: 'Visa Subclass', dataIndex: 'visaCategoryId', key: 'visaCategoryId',
                filters: visaCategoryList && visaCategoryList.map(x => ({ value: x, text: x }))

            },
            {
                title: 'Embassy Address', dataIndex: 'embassyAddress', key: 'embassyAddress',
                searchTextName: 'embassyAddress',
                filterRegex: true
            },
            {
                title: 'Embassy Contact', dataIndex: 'embassyContacts', key: 'embassyContacts',
                searchTextName: 'embassyContacts',
                filterRegex: true
            },
            {
                title: 'Visa Filing', dataIndex: 'visaFillingBy', key: 'visaFillingBy',
                filters: visaFillingBy && visaFillingBy.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Interview', dataIndex: 'interview', key: 'interview',
                filters: interviewArr && interviewArr.map(x => ({ value: x, text: x }))
            },
            {
                title: 'Part time Work', dataIndex: 'partTimeWork', key: 'partTimeWork',
                searchTextName: 'partTimeWork',
                filterRegex: true
            },
            {
                title: 'Standard Visa Processing', dataIndex: 'visaProcessingTime', key: 'visaProcessingTime',
                searchTextName: 'visaProcessingTime',
                filterRegex: true
            },
            {
                title: 'Tuition fee requirement', dataIndex: 'tutionFeeReq', key: 'tutionFeeReq',
                searchTextName: 'tutionFeeReq',
                filterRegex: true
            },
            {
                title: 'Estimated Health Cover - Single', dataIndex: 'singleOSHC', key: 'singleOSHC',
                searchTextName: 'singleOSHC'
            },
            {
                title: 'Estimated Health Cover - Dual', dataIndex: 'dualOSHC', key: 'dualOSHC',
                searchTextName: 'dualOSHC'
            },
            {
                title: 'Estimated Health Cover - Family', dataIndex: 'familyOSHC', key: 'familyOSHC',
                searchTextName: 'familyOSHC'
            },
            {
                title: 'Acceptable Funds', dataIndex: 'fundAcceptable', key: 'fundAcceptable',
                searchTextName: 'fundAcceptable',
                filterRegex: true,
                render: (text, record) => {

                    if (record.fundAcceptable) {
                        let u = record && record.fundAcceptable
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Refundable Bank Deposit', dataIndex: 'fundRefundable', key: 'fundRefundable',
                searchTextName: 'fundRefundable',
                filterRegex: true
            },
            {
                title: 'Acceptable Sponsors', dataIndex: 'fundSponsors', key: 'fundSponsors',
                searchTextName: 'fundSponsors',
                filterRegex: true,
                render: (text, record) => {

                    if (record.fundSponsors) {
                        let u = record && record.fundSponsors
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Education Loan Acceptable', dataIndex: 'fundEducation', key: 'fundEducation',
                filters: optionsArr && optionsArr.map(x => ({ value: x.value, text: x.label }))
            },
            {
                title: 'Visa Checklist',
                dataIndex: 'fundVisaChecklist',
                key: 'fundVisaChecklist',
                searchTextName: 'fundVisaChecklist',
                filterRegex: true,
                render: (val, record) => {

                    if (record && record.fundVisaChecklist && record.fundVisaChecklist.length > 0) {
                        let url = `${record.fundVisaChecklist[0].url}`
                        let ind = url && url.indexOf('http')
                        url = ind >= 0 ? `${url}` : `${API_URL}${url}`
                        return (<a href={url} target={'_blank'}>{url}</a>)
                    } else {
                        return (<></>)
                    }


                }
            },
            {
                title: 'Basic Admission Documents', dataIndex: 'enrollmentBasic', key: 'enrollmentBasic',
                searchTextName: 'enrollmentBasic',
                filterRegex: true,
                render: (text, record) => {


                    let u = record && record.enrollmentBasic
                    if (u && u.length <= 100) {
                        return <div>{u ? S(u).s : 'N/A'}</div>
                    } else {
                        return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                    }
                }


            },
            {
                title: 'Any Remarks', dataIndex: 'enrollmentRemarks', key: 'enrollmentRemarks',
                searchTextName: 'enrollmentRemarks',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.enrollmentRemarks) {
                        let u = record.enrollmentRemarks
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Procedure Steps', dataIndex: 'enrollmentProcedure', key: 'enrollmentProcedure',
                searchTextName: 'enrollmentProcedure',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.enrollmentProcedure) {
                        let u = record.enrollmentProcedure
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            }

        ]
        return (
            <PageHeaderWrapper title={`
          Total
          Countries : ${this.state.total}`}>
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                            {
                                userRights.checkRights("CountryReportExcelExport.view") ?
                                    <Button type={'default'}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.exportExcel()
                                        }}>Export Excel</Button>
                                    : null
                            }
                        </Col>
                    </Row>
                </Card>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        extraProps={{ scroll: { x: 8000 } }}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CountryReports)
